/*
  MINOTI 17.10.2026 (runda 6) - przewidywana data dostawy: koszyk, szuflada i karta produktu.
  Element <mn-eta> renderuje snippets/minoti-cart-eta.liquid (dni z shipping_matrix,
  kraj klienta, tekst w jezyku sklepu). Tu tylko daty, jedna logika dla wszystkich miejsc:
  - wysylka: dzis, jesli w Polsce jest dzien roboczy i przed 13:00 (czas polski),
    inaczej nastepny polski dzien roboczy,
  - dostawa: wysylka + dni robocze z tabeli (np. "2-3"), liczone w kraju odbiorcy:
    bez weekendow i bez swiat panstwowych tego kraju (regula dla kazdego z 25 krajow
    i kazdego roku, tabela RULES ponizej). Kraj spoza tabeli: weekendy oraz 1.01,
    25.12 i 26.12.
  - jeden zapis daty wszedzie: dzien tygodnia, dzien, miesiac ("Fri 23 - Tue 27 Oct").
  Custom element, wiec dziala tez po przerysowaniu szuflady przez motyw.
  Runda 6 (audyt 5, koszyk 1 i 2): wczesniej tranzyt liczyl polskie swieta dla kazdego
  kraju, a karta produktu liczyla daty inaczej (bez swiat).
*/
(function () {
  if (!window.customElements || customElements.get('mn-eta')) return;

  var CUTOFF_HOUR = 13;
  var TZ = 'Europe/Warsaw';
  var DAY = 86400000;

  function key(d) {
    var m = d.getUTCMonth() + 1, day = d.getUTCDate();
    return d.getUTCFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }

  function easter(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
  }

  /* Runda 7 (audyt 6 koszyk 4): swieta panstwowe wszystkich 25 krajow z shipping_matrix,
     liczone regula na kazdy rok (2026, 2027, 2028 i dalej), a nie lista dat do 2027.
     F: stale daty MM-DD. E: przesuniecie w dniach od Wielkanocy zachodniej (E-2 Wielki
     Piatek, E+1 Poniedzialek Wielkanocny, E+39 Wniebowstapienie, E+50 Zielone Swiatki,
     E+60 Boze Cialo). O: to samo od Wielkanocy prawoslawnej (BG, GR, RO).
     S: stale daty, ktore w sobote/niedziele przechodza na najblizszy wolny dzien roboczy.
     Liczymy tylko dni wolne w calym kraju; swieta regionalne (np. czesc landow DE, regiony
     ES) pomijamy. Gdzie prawo jest niejasne, dzien jest wpisany jako wolny: data wychodzi
     wtedy co najwyzej dzien pozniej, nigdy za wczesnie. Stan prawny: pazdziernik 2026.
     Zmiany: dopisac/usunac date w regule kraju, lat dopisywac nie trzeba. */
  var RULES = {
    PL: { F: '01-01 01-06 05-01 05-03 08-15 11-01 11-11 12-24 12-25 12-26', E: '1 60' },
    AT: { F: '01-01 01-06 05-01 08-15 10-26 11-01 12-08 12-25 12-26', E: '1 39 50 60' },
    BE: { F: '01-01 05-01 07-21 08-15 11-01 11-11 12-25', E: '1 39 50' },
    CZ: { F: '01-01 05-01 05-08 07-05 07-06 09-28 10-28 11-17 12-24 12-25 12-26', E: '-2 1' },
    SK: { F: '01-01 01-06 05-01 05-08 07-05 08-29 09-01 09-15 11-01 11-17 12-24 12-25 12-26', E: '-2 1' },
    DE: { F: '01-01 05-01 10-03 12-25 12-26', E: '-2 1 39 50' },
    NL: { F: '01-01 12-25 12-26', E: '1 39 50', K: true },
    HR: { F: '01-01 01-06 05-01 05-30 06-22 08-05 08-15 11-01 11-18 12-25 12-26', E: '1 60' },
    HU: { F: '01-01 03-15 05-01 08-20 10-23 11-01 12-24 12-25 12-26', E: '-2 1 50' },
    LT: { F: '01-01 02-16 03-11 05-01 06-24 07-06 08-15 11-01 11-02 12-24 12-25 12-26', E: '1' },
    LU: { F: '01-01 05-01 05-09 06-23 08-15 11-01 12-25 12-26', E: '1 39 50' },
    ES: { F: '01-01 01-06 05-01 08-15 10-12 11-01 12-06 12-08 12-25', E: '-3 -2' },
    DK: { F: '01-01 06-05 12-24 12-25 12-26 12-31', E: '-3 -2 1 39 50' },
    EE: { F: '01-01 02-24 05-01 06-23 06-24 08-20 12-24 12-25 12-26', E: '-2' },
    FI: { F: '01-01 01-06 05-01 12-06 12-24 12-25 12-26', E: '-2 1 39', M: true },
    FR: { F: '01-01 05-01 05-08 07-14 08-15 11-01 11-11 12-25', E: '1 39 50' },
    IE: { IE: true },
    IT: { F: '01-01 01-06 04-25 05-01 06-02 08-15 10-04 11-01 12-08 12-25 12-26', E: '1' },
    LV: { F: '01-01 05-01 06-23 06-24 12-24 12-25 12-26 12-31', S: '05-04 11-18', E: '-2 1' },
    SI: { F: '01-01 01-02 02-08 04-27 05-01 05-02 06-25 08-15 10-31 11-01 12-25 12-26', E: '1' },
    SE: { F: '01-01 01-06 05-01 06-06 12-24 12-25 12-26 12-31', E: '-2 1 39', M: true },
    BG: { S: '01-01 03-03 05-01 05-06 05-24 09-06 09-22 12-24 12-25 12-26', O: '-2 -1 1' },
    GR: { F: '01-01 01-06 03-25 05-01 08-15 10-28 12-25 12-26', O: '-48 -2 1 50' },
    PT: { F: '01-01 04-25 05-01 06-10 08-15 10-05 11-01 12-01 12-08 12-25', E: '-2 60' },
    RO: { F: '01-01 01-02 01-06 01-07 01-24 05-01 06-01 08-15 11-30 12-01 12-25 12-26', O: '-2 1 50' }
  };

  var cache = {};

  /* Wielkanoc prawoslawna: kalendarz julianski + 13 dni (poprawne dla lat 1900-2099). */
  function orthodoxEaster(year) {
    var a = year % 4, b = year % 7, c = year % 19;
    var d = (19 * c + 15) % 30, e = (2 * a + 4 * b - d + 34) % 7;
    var month = Math.floor((d + e + 114) / 31), day = ((d + e + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day) + 13 * DAY);
  }

  function utc(year, md) {
    var p = md.split('-');
    return new Date(Date.UTC(year, +p[0] - 1, +p[1]));
  }

  function weekend(d) {
    var wd = d.getUTCDay();
    return wd === 0 || wd === 6;
  }

  /* n-ty poniedzialek miesiaca (n = -1: ostatni) */
  function monday(year, month, n) {
    var d;
    if (n > 0) {
      d = new Date(Date.UTC(year, month - 1, 1));
      while (d.getUTCDay() !== 1) d = new Date(d.getTime() + DAY);
      return new Date(d.getTime() + (n - 1) * 7 * DAY);
    }
    d = new Date(Date.UTC(year, month, 0));
    while (d.getUTCDay() !== 1) d = new Date(d.getTime() - DAY);
    return d;
  }

  /* Swieta z dniem zastepczym: najpierw te w tygodniu, potem te z weekendu
     przechodza na najblizszy dzien roboczy, ktory nie jest juz wolny
     (np. BG 2028: 24.12 w niedziele -> 27.12, bo 25 i 26 sa wolne i tak). */
  function substitute(list, year, mds) {
    var days = mds.map(function (md) { return utc(year, md); });
    days.forEach(function (d) { if (!weekend(d)) list[key(d)] = true; });
    days.forEach(function (d) {
      if (!weekend(d)) return;
      var n = d;
      do { n = new Date(n.getTime() + DAY); } while (weekend(n) || list[key(n)]);
      list[key(n)] = true;
    });
  }

  function irish(year) {
    var list = {};
    var feb1 = utc(year, '02-01');
    list[key(feb1.getUTCDay() === 5 ? feb1 : monday(year, 2, 1))] = true;
    list[key(new Date(easter(year).getTime() + DAY))] = true;
    [monday(year, 5, 1), monday(year, 6, 1), monday(year, 8, 1), monday(year, 10, -1)].forEach(function (d) {
      list[key(d)] = true;
    });
    substitute(list, year, ['01-01', '03-17', '12-25', '12-26']);
    return list;
  }

  function holidays(country, year) {
    var id = country + year;
    if (cache[id]) return cache[id];
    var r = RULES[country];
    var list = {};
    if (!r) {
      ['01-01', '12-25', '12-26'].forEach(function (md) { list[year + '-' + md] = true; });
    } else if (r.IE) {
      list = irish(year);
    } else {
      (r.F ? r.F.split(' ') : []).forEach(function (md) { list[year + '-' + md] = true; });
      var e = easter(year).getTime();
      (r.E ? r.E.split(' ') : []).forEach(function (o) { list[key(new Date(e + (+o) * DAY))] = true; });
      var o2 = orthodoxEaster(year).getTime();
      (r.O ? r.O.split(' ') : []).forEach(function (o) { list[key(new Date(o2 + (+o) * DAY))] = true; });
      if (r.K) {
        /* NL: Dzien Krola 27.04, w niedziele 26.04 */
        var k = utc(year, '04-27');
        list[key(k.getUTCDay() === 0 ? utc(year, '04-26') : k)] = true;
      }
      if (r.M) {
        /* SE, FI: Wigilia sw. Jana, piatek miedzy 19 a 25 czerwca */
        var m = utc(year, '06-19');
        while (m.getUTCDay() !== 5) m = new Date(m.getTime() + DAY);
        list[key(m)] = true;
      }
      if (r.S) substitute(list, year, r.S.split(' '));
    }
    cache[id] = list;
    return list;
  }

  function isWorkingDay(d, country) {
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    return !holidays(country, d.getUTCFullYear())[key(d)];
  }

  function nextWorkingDay(d, country) {
    var n = new Date(d.getTime());
    do {
      n = new Date(n.getTime() + DAY);
    } while (!isWorkingDay(n, country));
    return n;
  }

  function addWorkingDays(d, count, country) {
    var n = new Date(d.getTime());
    for (var i = 0; i < count; i++) n = nextWorkingDay(n, country);
    return n;
  }

  function warsawNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) {
      parts[p.type] = p.value;
    });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      hour: +parts.hour
    };
  }

  /* Jeden zapis: "Fri 23 – Tue 27 Oct", przy dwoch miesiacach "Fri 30 Oct – Tue 3 Nov".
     Skladany recznie, bo formatRange rozni sie miedzy przegladarkami. */
  function formatRange(locale, a, b) {
    var full = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    if (a.getTime() === b.getTime()) return full.format(a);
    var sameMonth = a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear();
    var first = full.format(a);
    if (sameMonth && typeof full.formatToParts === 'function') {
      /* ten sam zapis co pelna data, tylko bez miesiaca (np. "Mi., 23." / "mié, 14") */
      var out = [];
      full.formatToParts(a).forEach(function (p) {
        if (p.type === 'month') {
          var last = out[out.length - 1];
          if (last && last.type === 'literal') last.value = last.value.trim();
          return;
        }
        out.push({ type: p.type, value: p.value });
      });
      first = out.map(function (p) { return p.value; }).join('').trim();
    }
    return first + ' – ' + full.format(b);
  }

  customElements.define('mn-eta', class extends HTMLElement {
    connectedCallback() {
      try {
        var days = (this.getAttribute('data-days') || '').split(/[-–]/).map(function (n) {
          return parseInt(n, 10);
        });
        var min = days[0];
        var max = isNaN(days[1]) ? min : days[1];
        if (isNaN(min) || min < 0 || max < min || max > 30) return;
        if (min < 1) min = 1;
        if (max < min) max = min;

        var country = (this.getAttribute('data-country') || 'PL').toUpperCase();
        var now = warsawNow();
        var dispatch = isWorkingDay(now.date, 'PL') && now.hour < CUTOFF_HOUR ? now.date : nextWorkingDay(now.date, 'PL');
        var from = addWorkingDays(dispatch, min, country);
        var to = addWorkingDays(dispatch, max, country);

        var locale = this.getAttribute('data-locale') || 'en';
        if (locale === 'en') locale = 'en-GB';
        var text = this.getAttribute('data-text') || '{range}';
        this.textContent = text.replace('{range}', formatRange(locale, from, to));
        this.hidden = false;
      } catch (e) {
        this.hidden = true;
      }
    }
  });
})();
